import { render, staticRenderFns } from "./DispatchNoteDialog.vue?vue&type=template&id=c4d65724"
import script from "./DispatchNoteDialog.vue?vue&type=script&lang=js"
export * from "./DispatchNoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports